export enum DemoType {
  PLAYABLE = 'playable',
  VIDEO = 'video',
}

export interface ProjectDemoModel {
  // 创建时间
  created_time: number
  // 删除时间
  deleted_time: number
  // 主键ID
  id: number
  // demo名称
  name: string
  // 来源广告主id
  src_adv_id: number
  // 来源广告主名称
  src_adv_name: string
  // 来源项目id
  src_project_id: number
  // 来源项目类型
  src_project_type: string
  // 缩略图
  thumb_url: string
  // demo类型
  type: DemoType
  // 更新时间
  updated_time: number
}

export interface GetProjectDemoListResponse {
  // demo列表
  list: ProjectDemoModel[] | null
  // 总数
  total: number
}

export interface GetProjectDemoListQuery {
  // demo id
  id?: ProjectDemoModel['id'] | ''
  // 名称
  name?: ProjectDemoModel['name']
  // 排序方式
  order?:
    | ProjectDemoModel['created_time']
    | ProjectDemoModel['updated_time']
    | ''
  // 来源广告主id
  src_adv_id?: ProjectDemoModel['src_adv_id'] | ''
  // 来源项目id
  src_project_id?: ProjectDemoModel['src_project_id'] | ''
  // 来源项目类型 pt/ps
  src_project_type?: ProjectDemoModel['src_project_type'] | ''
}

export interface AddProjectDemoParams
  extends Pick<
      GetProjectDemoListQuery,
      'name' | 'src_adv_id' | 'src_project_id' | 'src_project_type'
    >,
    Partial<Pick<ProjectDemoModel, 'thumb_url'>> {}

export interface ProjectSourceInfoModel
  extends Pick<
    ProjectDemoModel,
    'src_adv_id' | 'src_project_id' | 'src_project_type' | 'thumb_url' | 'type'
  > {
  src_adv_name: string
  src_project_name: string
}

export interface ProjectDemoPushLogModel {
  // 主键ID
  id: number
  // 推送项目名称
  name: string
  // demo id
  demo_project_id: number
  // 来源广告主id
  adv_id: number
  // 来源广告主名称
  adv_name: string
  // demo类型
  type: DemoType
  // 复制id
  copied_id: number
  // 更新时间
  updated_time: number
  // 创建时间
  created_time: number
}

export interface GetProjectDemoPushLogListResponse {
  // demo列表
  list: ProjectDemoPushLogModel[] | null
  // 总数
  total: number
}
